module.exports = __webpack_public_path__ + "static/img/1_1_2.3a674865.jpg";